var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReanimatedFlatList = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _View = require("./View");
var _createAnimatedComponent = _interopRequireDefault(require("../../createAnimatedComponent/createAnimatedComponent"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = [
    "itemLayoutAnimation"
];
var _this = this, _jsxFileName = "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/component/FlatList.tsx";
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var AnimatedFlatList = (0, _createAnimatedComponent.default)(_reactNative.FlatList);
var createCellRenderer = function createCellRenderer(itemLayoutAnimation, cellStyle) {
    var cellRenderer = function cellRenderer(props) {
        return (0, _jsxRuntime.jsx)(_View.AnimatedView, {
            layout: itemLayoutAnimation,
            onLayout: props.onLayout,
            style: cellStyle,
            children: props.children
        });
    };
    return cellRenderer;
};
var ReanimatedFlatList = exports.ReanimatedFlatList = (0, _react.forwardRef)(function(props, ref) {
    var itemLayoutAnimation = props.itemLayoutAnimation, restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
    var cellStyle = restProps != null && restProps.inverted ? restProps != null && restProps.horizontal ? styles.horizontallyInverted : styles.verticallyInverted : undefined;
    if (!("scrollEventThrottle" in restProps)) {
        restProps.scrollEventThrottle = 1;
    }
    var cellRenderer = _react.default.useMemo(function() {
        return createCellRenderer(itemLayoutAnimation, cellStyle);
    }, [
        cellStyle
    ]);
    return (0, _jsxRuntime.jsx)(AnimatedFlatList, Object.assign({
        ref: ref
    }, restProps, {
        CellRendererComponent: cellRenderer
    }));
});
var styles = _reactNative.StyleSheet.create({
    verticallyInverted: {
        transform: [
            {
                scaleY: -1
            }
        ]
    },
    horizontallyInverted: {
        transform: [
            {
                scaleX: -1
            }
        ]
    }
});
